/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-bitwise */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './index.module.css';

const nearestIndex = (
  currentPosition,
  sectionPositionArray,
  startIndex,
  endIndex,
) => {
  if (startIndex === endIndex) return startIndex;
  if (startIndex === endIndex - 1) {
    if (
      Math.abs(
        sectionPositionArray[startIndex].headerRef.current?.offsetTop
          - currentPosition,
      )
      < Math.abs(
        sectionPositionArray[endIndex].headerRef.current?.offsetTop
          - currentPosition,
      )
    ) return startIndex;
    return endIndex;
  }
  const nextNearest = ~~((startIndex + endIndex) / 2);
  const a = Math.abs(
    sectionPositionArray[nextNearest].headerRef.current?.offsetTop
        - currentPosition,
  );
  const b = Math.abs(
    sectionPositionArray[nextNearest + 1].headerRef.current?.offsetTop
        - currentPosition,
  );
  if (a < b) {
    return nearestIndex(
      currentPosition,
      sectionPositionArray,
      startIndex,
      nextNearest,
    );
  }
  return nearestIndex(
    currentPosition,
    sectionPositionArray,
    nextNearest,
    endIndex,
  );
};

export default function FloatBullets({ sections }) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const handleScroll = (e) => {
      const index = nearestIndex(
        window.scrollY,
        sections,
        0,
        sections.length - 1,
      );
      setActiveIndex(index);
    };
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={Styles.container}>
      {sections.map((section, index) => (
        <div className={activeIndex === index ? classNames(Styles.bullet, Styles.activeBullet) : classNames(Styles.bullet)}>
          <a href={`#${section.id}`} className={Styles.bulletLink} />
        </div>
      ))}
    </div>
  );
}

FloatBullets.propTypes = {
  sections: PropTypes.array,
};

FloatBullets.defaultProps = {
  sections: [],
};
